import { combineReducers } from 'redux';

import slices from './slices';

export const reducers = {
  applicants: slices.applicants.reducer,
};

const reducer = combineReducers({
  applicants: reducers.applicants,
});

export default reducer;
